/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionRule } from '../../models/distribution-rule';

export interface GetRule$Params {
  'Active-Tenant-Identifier': string;
  ruleId: string;
}

export function getRule(http: HttpClient, rootUrl: string, params: GetRule$Params, context?: HttpContext): Observable<StrictHttpResponse<DistributionRule>> {
  const rb = new RequestBuilder(rootUrl, getRule.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('ruleId', params.ruleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DistributionRule>;
    })
  );
}

getRule.PATH = '/distribution-rules/{ruleId}';
